import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import {withStyles} from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import Slider from "@material-ui/lab/Slider";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TilingIcon from "../../../../icons/TilingIcon";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import {destroyTiling, createTiling, setTilePadding} from "../../AC/tiling";
import Mediator from "../../services/Mediator";
import {TILING_CREATED, TILING_DESTROYED} from "../../constants/event-types";
import {Button} from "@material-ui/core";
import UndoIcon from "@material-ui/icons/Undo";

const styles = {
  rootWithArrow: {
    padding: `12px 2px 12px 8px`,
    borderRadius: `3px`
  },
  root: {
    padding: `12px 8px`,
    borderRadius: `3px`
  },
  slider: {
    padding: `22px 0px`
  },
  track: {
    backgroundColor: `#838587`
  },
  thumb: {
    backgroundColor: `#838587`
  },
  button: {
    borderRadius: `50px`,
    width: `100%`,
    height: `40px`
  }
};

class Tiling extends Component {
  static propTypes = {
    classes: PropTypes.object,
    selected: PropTypes.object,
    createTiling: PropTypes.func,
    destroyTiling: PropTypes.func,
    setTilePadding: PropTypes.func
  };
  state = {
    anchorEl: null,
    tilePadding: Mediator.isTiling(this.props.selected)
      ? this.props.selected.tilePadding
      : 0
  };
  componentDidMount() {
    Provider.subscribe(TILING_CREATED, this.onTilingChanged);
    Provider.subscribe(TILING_DESTROYED, this.onTilingChanged);
  }
  componentWillUnmount() {
    Provider.unsubscribe(TILING_CREATED, this.onTilingChanged);
    Provider.unsubscribe(TILING_DESTROYED, this.onTilingChanged);
  }
  onTilingChanged = (_, target) => {
    this.setStateFromObject(target);
  };
  setStateFromObject = (object) => {
    const {tilePadding} = object;
    this.setState({
      tilePadding
    });
    this.props.setTilePadding(tilePadding);
  };
  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };
  handleClose = () => {
    this.setState({anchorEl: null});
  };
  handleChange = (_, tilePadding) => {
    this.setState({
      tilePadding
    });
    this.props.setTilePadding(tilePadding);
  };
  destroyTiling = () => {
    this.props.destroyTiling();
    this.setState({anchorEl: null});
  };
  createTiling = (typeOfTiling) => () => {
    this.props.createTiling(typeOfTiling);
  };
  render() {
    const {anchorEl, tilePadding} = this.state;
    const {selected, classes} = this.props;
    const isTiling = Mediator.isTiling(selected);
    return selected ? (
      <div className="panel-control__item">
        <Tooltip title="Размножить">
          <IconButton
            aria-owns={anchorEl ? `tiling-menu` : void 0}
            aria-haspopup="true"
            classes={{root: classes.rootWithArrow}}
            onClick={this.handleClick}
          >
            <TilingIcon />
            <ArrowDropDownIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="tiling-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {isTiling
            ? [
                <MenuItem key={`slider`}>
                  <Slider
                    classes={{
                      container: classes.slider,
                      track: classes.track,
                      thumb: classes.thumb
                    }}
                    min={0}
                    max={100}
                    value={tilePadding}
                    aria-labelledby="label"
                    onChange={this.handleChange}
                  />
                  <span className="tile-padding" style={{marginLeft: `10px`}}>
                    {tilePadding.toFixed()}
                  </span>
                </MenuItem>,
                <MenuItem
                  key={`none`}
                  onClick={this.destroyTiling}
                  selected={selected.tile && `none` === selected.tile.type}
                >
                  <Button variant="outlined" className={classes.button}>
                    <UndoIcon />
                    Отменить
                  </Button>
                </MenuItem>
              ]
            : null}
          {[
            {
              type: `basic`,
              title: `базовый`,
              onClick: this.createTiling(`basic`)
            },
            {
              type: `centered`,
              title: `центрированый`,
              onClick: this.createTiling(`centered`)
            },
            {
              type: `half-brick`,
              title: `горизонтальное смещение`,
              onClick: this.createTiling(`half-brick`)
            },
            {
              type: `half-drop`,
              title: `вертикальное смещение`,
              onClick: this.createTiling(`half-drop`)
            },
            {
              type: `mirror`,
              title: `зеркальный`,
              onClick: this.createTiling(`mirror`)
            }
          ].map(({type, title, onClick}) => (
            <MenuItem
              key={type}
              onClick={onClick}
              selected={selected.tile && type === selected.tile.type}
            >
              <Tooltip title={title}>
                <span className={`tiling-type tiling-type_${type}`} />
              </Tooltip>
            </MenuItem>
          ))}
        </Menu>
      </div>
    ) : null;
  }
}

export default connect(null, {
  destroyTiling,
  createTiling,
  setTilePadding
})(withErrorBoundary(withStyles(styles)(Tiling)));
